import { useMutation } from "@tanstack/react-query";
import api from "../lib/apiClient";

export const useSubmitEnquiry = () => {
	return useMutation({
		mutationFn: async (payload) => {
		const { data } = await api.post("/enquiry", payload);
		return data;
		},
	});
};